"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.offerCreator.name': '报价创建器',
    'tools.offerCreator.description': '从用户消息中检测并完善报价/报价单信息，包括公司详情、税务类型和商业活动',
};
